import { contracts } from '../../config/blockchain';
import Log from '../../utils/Log';

export const FETCH_MY_ITEMS = 'FETCH_MY_ITEMS';

export const fetchMyItems = (myWalletAddress) => async (dispatch, getState) =>
  contracts.stickItem.getAllItemsFrom(myWalletAddress, (error, myItems) => {
    if (!error) {
      Log.info(`MyItems count: ${myItems.length}.`);

      Promise.all(myItems.map(myItem => {
        return new Promise((resolve, reject) => {
          contracts.stickItem.tokenURI(myItem, (error, tokenUri) => {
            if (error) {
              Log.error(`Failed when trying to get tokenURI. ${error}.`);
              resolve(false); // Always resolve - Promise.all is all or nothing
            }

            window.fetch(tokenUri).then((response) => {
              response.json().then((schema) => {
                resolve({
                  id: myItem.toNumber(),
                  uri: tokenUri,
                  schema: schema
                });
              }).catch((error) => {
                Log.error(`Failed when trying to parse JSON. ${error}.`);
                resolve(false);
              });
            }).catch((error) => {
              Log.error(`Failed when trying to fetch JSON. ${error}.`);
              resolve(false);
            });
          });
        });
      })).then(myItems => {
        dispatch({
          type: FETCH_MY_ITEMS,
          payload: myItems.filter(Boolean) // Remove resolve(false) from array
        });
      });
    } else {
      Log.error('Failed when tried to get myItems.');
    }
  });



// WEBPACK FOOTER //
// ./src/redux/actions/myItemsActions.js